import { FieldModel } from "components/FieldModel"

export class LoginSceneModel {

    public globalError: string = null
    public isLoading: boolean = false
    public emailModel: FieldModel<string> = new FieldModel("")
    public passwordModel: FieldModel<string> = new FieldModel("")

}